import React, { createContext, useContext, useState, useEffect } from "react";
import mailClientAPI from "../api/mail-client-api";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadUserInfo = async () => {
    // Only load if user is authenticated
    if (!mailClientAPI.isAuthenticated()) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const response = await mailClientAPI.getMe();
      setUserInfo(response.Output);
    } catch (err) {
      console.error("Error loading user info:", err);
      setError(err);
      setUserInfo(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUserInfo();
  }, []);

  // Function to refresh user info
  const refreshUserInfo = async () => {
    if (!mailClientAPI.isAuthenticated()) {
      setUserInfo(null);
      return;
    }

    try {
      setError(null);
      const response = await mailClientAPI.getMe();
      setUserInfo(response.Output);
    } catch (err) {
      console.error("Error refreshing user info:", err);
      setError(err);
      setUserInfo(null);
    }
  };

  const value = {
    userInfo,
    loading,
    error,
    refreshUserInfo,
    loadUserInfo,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};

